import request from "@/utils/request";

// 获取最终签章文件状态
export function getEsignpdfStatus(contractId) {
  return request({
    url: `/api/saas/mobile/esignpdf/getStatus.do?contractId=${contractId}`,
    method: "GET"
  });
}

// 获取最终签章文件
export function getEsignpdfDocuments(contractId) {
  return request({
    url: `/api/saas/mobile/esignpdf/getDocuments.do?contractId=${contractId}`,
    method: "GET"
  });
}

// 生成最终签章文件
export function genSignFile(contractId) {
  return request({
    url: `/api/saas/mobile/esignpdf/getSignFileList.do?contractId=${contractId}`,
    method: "POST",
    timeout: 30000 // 生成签章文件可能会很慢，单独设置超时时间30s
  });
}